import React, { useEffect, useState } from 'react';
import styles from './Platforms.module.scss'
import PlatformsGrid from "../../../components/PlatformsGrid/PlatformsGrid";
import { $t } from "../../../helpers/translator";
import { useHistory } from "react-router-dom";
import Loader from '../../../components/miscellaneous/Loader/Loader';
import PlatformsTable from "../../../components/PlatformsTable/PlatformsTable";


const AdminPlatforms = (props) => {

    const history = useHistory();


    //TODO: add button form managing platform versions:
    function goToVersionManagement(e) {
        e.stopPropagation();
        console.error(e);
        history.push(`/equipment/platform-versions`)
    }

    return (
        <div className={ styles.container }>
            <div className={ `${styles[ 'row' ]} ${styles[ 'flex-end' ]}` }>
                <div className={ 'alma-button' }
                    onClick={ (e) => goToVersionManagement(e) }>{ $t('global.machines.versions.manageVersions') }
                </div>
            </div>

            <PlatformsTable userType={ 5 } getUsage={ false } />
        </div>
    )
}

export default AdminPlatforms;
